import moment from "moment";

export const formatCustomDate = (date) => {
  const validDate = moment(date, moment.ISO_8601, true); // Strict ISO format validation
  return validDate.isValid() ? validDate.format("DD-MM-YYYY HH:mm A") : '';
};



export const formatCustomDateWithoutTime = (date) => {
  const validDate = moment(date, moment.ISO_8601, true); // Strict ISO format validation
  return validDate.isValid() ? validDate.format("DD-MM-YYYY") : '';
};